/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { Component, Input } from '@angular/core';
import { DeleteServiceTypeDialogConfig } from './types';

@Component({
  selector: 'sysque-delete-service-type',
  templateUrl: './delete-service-type.component.html',
  styleUrl: './delete-service-type.component.scss',
  standalone: false
})
export class DeleteServiceTypeComponent {
  @Input() config: DeleteServiceTypeDialogConfig;

  /**
 * Change service type name
 */
  public applyChanges(): void {
    this.config.apply();
  }

  /**
 * Discard all changes
 */
  public discardChanges(): void {
    this.config.close();
  }

  /**
 * Close the dialog
 */
  public closeDialog(): void {
    this.config.close();
  }
}
